"use client";

import "./MessageLoader.css";

export function MessageLoader(): React.JSX.Element {
  return (
    <div className="flex items-center py-4">
      <div className="flex items-end gap-1.5 ai-bouncing-cubes">
        <div className="ai-cube ai-cube-1" />
        <div className="ai-cube ai-cube-2" />
        <div className="ai-cube ai-cube-3" />
      </div>
    </div>
  );
}
